<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <div class="brand">
              <h1>Secours populaire français</h1>
              <h3>
                " Tout ce qui est humain est nôtre "
              </h3>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section section-signup page-header" :style="signupImage">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-33 md-medium-size-40 md-small-size-50 md-xsmall-size-70 mx-auto text-center"
            >
              <md-card>
                <md-card-header
                  class="headerLog"
                  style="background: linear-gradient(80deg,#f95050,#1818fa);"
                >
                  <h3 style="text-align:center">
                    Saississez vos informations
                  </h3>
                </md-card-header>

                <form @submit="login" autocomplete="on">
                  <md-field class="md-form-group" slot="inputs">
                    <md-icon>face</md-icon>
                    <label>Numéro collecteur</label>
                    <md-input
                      v-model="user.username"
                      name="username"
                      required
                    ></md-input>
                    <span class="my-button">
                      <md-icon class="md-primary">info</md-icon>
                      <span class="my-tooltip"
                        >Veuillez insérer <b>le numéro de collecteur</b> qui se
                        trouve sur la carte bénévole qui vous a été
                        transmise.</span
                      >
                    </span>
                  </md-field>
                  <md-field class="md-form-group" slot="inputs">
                    <md-icon>event</md-icon>

                    <!-- <datepicker v-model="user.password" format= "DD/MM/YYYY" md-immediately md-model-type="String" >
                    <label>Date de naissance</label>
                  </datepicker> -->

                    <label>Mot de passe</label>
                    <md-input
                      v-model="user.password"
                      name="password"
                      required
                    ></md-input>

                    <span class="my-button">
                      <md-icon class="md-primary">info</md-icon>
                      <span class="my-tooltip"
                        >Veuillez insérer votre <b>date de naissance</b>. Si
                        lors de la création de votre compte vous n'avez pas
                        renseigné votre date de naissance, veuillez alors
                        insérer la date suivante : <b>01/01/2000</b>.</span
                      >
                    </span>
                  </md-field>

                  <!-- <label>Date de naissance</label>
                   </md-datepicker><md-datepicker format="dd/mm/yyyy"> -->
                  <!--  <md-dialog-confirm
      :md-active.sync="active"
      md-title="Se connecter"
      md-content="Etes vous sûre de vouloir vous connecter"
      md-confirm-text="Agree"
      md-cancel-text="Disagree"
      @md-cancel="onCancel"
      @md-confirm="onConfirm" /> -->

                  <md-button
                    slot="footer"
                    class="md-lg md-primary btn"
                    type="submit"
                  >
                    Connexion
                  </md-button>
                </form>
              </md-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datepicker from "vue-date-picker";

import axios from "../http-common";
import router from "../router";
import { mapActions } from "vuex";
import moment from "moment";
import { LOCAL_STORAGE } from "../utils/localStorage";

export default {
  components: {},
  name: "index",
  bodyClass: "index-page",
  props: {
    image: {
      type: String,
      default: require("@/assets/img/Benevol.jpg"),
    },
    signup: {
      type: String,
      default: require("@/assets/img/volunters.webp"),
    },
  },
  data() {
    return {
      mask: "##/##/####",
      user: {
        username: "",
        password: "",
        // leafShow: false,
      },
      /*   active: false,
      value:null */
    };
  },
  watch: {
    "user.password": function(newValue, oldValue) {
      if (newValue.length == 2 && oldValue.length == 1) {
        this.user.password += "/";
      } else if (newValue.length == 5 && oldValue.length == 4) {
        this.user.password += "/";
      }
    },
  },
  methods: {
    //recupérer les actions du store et de les maper
    ...mapActions(["setUser"]),
    login(e) {
      e.preventDefault();

      axios
        .post("/api/auth/signin", this.user)
        .then((response) => {
          // console.log(response);
          this.setUser(response.data);
          LOCAL_STORAGE.SET({ key: "auth", value: response.data });

          router.push("/basic");
        })
        .catch((error) => {
          // console.log(error.response)
          alert("numéro collecteur ou mot de passe incorrecte");
        });
      //console.log("Login en cours");
    },

    onConfirm() {
      this.value = "Agreed";
    },
    onCancel() {
      this.value = "Disagreed";
    },
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`,
      };
    },
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`,
      };
    },
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },
  },

  mounted() {
    /*  this.leafActive();
    window.addEventListener("resize", this.leafActive); */
  },
  beforeDestroy() {
    /* window.removeEventListener("resize", this.leafActive); */
  },
};
</script>
<style lang="scss">
h3 {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}
.my-tooltip {
  visibility: hidden;
  position: absolute;
  bottom: 20%;
  left: 50%;

  transform: translateX(-50%);
  padding: 5px;
  background-color: #6a219b;
  color: #fff;
  font-size: 22px;
  border-radius: 3px;
  z-index: 1;
  border-radius: 0.5rem;

  font-family: bold;
}

.my-button:hover .my-tooltip {
  visibility: visible;
}
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}
.btn {
  border-radius: 1em !important;
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
